module.exports = __webpack_public_path__ + "img/10.cb43c7a1.jpg";